<template>
  <div>
    <van-nav-bar
      :title="topData.name"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <!-- <van-overlay :show="loadingMask">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#ee0a24" />
        </div>
      </div>
    </van-overlay> -->
    <div style="background: #ebedf0; font-size: 14px">
      <van-row>
        <van-col span="10">
          <van-row style="padding: 14px 0px">
            <van-col
              span="24"
              style="text-align: center; font-size: 22px"
              v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
              >{{ topData.price }}</van-col
            >
          </van-row>
          <van-row style="text-align: center">
            <van-col
              span="12"
              v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
              >{{ topData.increase }}</van-col
            >
            <van-col
              span="12"
              v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
              >{{ topData.increasePercent }}%</van-col
            >
          </van-row>
        </van-col>
        <van-col span="14">
          <van-row style="text-align: center">
            <van-col span="8"
              ><p style="margin: 5px 0px">最高</p>
              <p style="margin: 5px 0px">{{ topData.maxPrice }}</p></van-col
            >
            <van-col span="8"
              ><p style="margin: 5px 0px">今开</p>
              <p style="margin: 5px 0px">
                {{ topData.todayOpenPrice }}
              </p></van-col
            >
            <van-col span="8"
              ><p style="margin: 5px 0px">成交量</p>
              <p v-if="topData.num < 10000" style="margin: 5px 0px">{{ topData.num }}<span style="font-size: 12px;">手</span></p>
              <p v-else-if="(10000 <= topData.num) && (topData.num < 100000000)" style="margin: 5px 0px">{{ parseFloat((topData.num)/10000).toFixed(1) }}<span style="font-size: 12px;">万手</span></p>
              <p v-else-if="100000000 <= topData.num" style="margin: 5px 0px">{{ parseFloat((topData.num)/100000000).toFixed(1) }}<span style="font-size: 12px;">亿手</span></p>
              </van-col
            >
          </van-row>
          <van-row style="text-align: center">
            <van-col span="8"
              ><p style="margin: 5px 0px">最低</p>
              <p style="margin: 5px 0px">{{ topData.minPrice }}</p></van-col
            >
            <van-col span="8"
              ><p style="margin: 5px 0px">昨收</p>
              <p style="margin: 5px 0px">
                {{ topData.yesterdayClosePrice }}
              </p></van-col
            >
            <van-col span="8"
              ><p style="margin: 5px 0px">成交额</p>
              <p style="margin: 5px 0px" v-if="topData.totalAccount < 10000">{{ topData.totalAccount }}<span style="font-size: 12px;">万</span></p>
              <p style="margin: 5px 0px" v-else >{{ parseFloat((topData.totalAccount)/10000).toFixed(1) }}<span style="font-size: 12px;">亿</span></p>
              </van-col
            >
          </van-row>
        </van-col>
      </van-row>

      <van-row>
        <van-col span="10">
          <van-row style="text-align: center">
            <van-col span="12"
              ><p style="margin: 5px 0px">涨停</p>
              <p style="margin: 5px 0px">{{ topData.hardenPrice }}</p></van-col
            >
            <van-col span="12"
              ><p style="margin: 5px 0px">量比</p>
              <p style="margin: 5px 0px">{{ topData.volumeRatio }}</p></van-col
            >
          </van-row>
          <van-row style="text-align: center">
            <van-col span="12"
              ><p style="margin: 5px 0px">跌停</p>
              <p style="margin: 5px 0px">{{ topData.dropPrice }}</p></van-col
            >
            <van-col span="12">
              <p style="margin: 5px 0px">委比</p>
              <p style="margin: 5px 0px">{{ topData.appointment }}%</p>
            </van-col>
          </van-row>
        </van-col>
        <van-col span="14">
          <van-row style="text-align: center">
            <van-col span="8">
              <p style="margin: 5px 0px">均价</p>
              <p style="margin: 5px 0px">{{ topData.average }}</p></van-col
            >
            <van-col span="8"
              ><p style="margin: 5px 0px">市盈率</p>
              <p style="margin: 5px 0px">
                {{ topData.priceToEarnings }}
              </p></van-col
            >
            <van-col span="8"
              ><p style="margin: 5px 0px">总市值</p>
              <p style="margin: 5px 0px">
                {{ topData.aggregatealueListedStock }}<span style="font-size: 12px;">亿</span>
              </p></van-col
            >
          </van-row>
          <van-row style="text-align: center">
            <van-col span="8"
              ><p style="margin: 5px 0px">振幅</p>
              <p style="margin: 5px 0px">{{ topData.swing }}%</p></van-col
            >
            <van-col span="8"
              ><p style="margin: 5px 0px">换手率</p>
              <p style="margin: 5px 0px">{{ topData.turnoverRate }}%</p></van-col
            >
            <van-col span="8"
              ><p style="margin: 5px 0px">流通值</p>
              <p style="margin: 5px 0px">
                {{ topData.stockMarketsFell }} <span style="font-size: 12px;">亿</span>
              </p></van-col
            >
          </van-row>
        </van-col>
      </van-row>
    </div>
    <div>
      <van-tabs v-model="activeKlineTab" @click="chartChange">
        <van-tab title="分时" name="timeshare"
          ><div id="timeshare" style="width: auto; height: 400px"></div>
        </van-tab>
        <van-tab title="日K" name="dayK">
          <div id="dayK" style="height:50vh;"/>
        </van-tab>
        <van-tab title="周K" name="weekK">
          <div id="weekK" style="height:50vh;"/>
        </van-tab>
        <van-tab title="月K" name="monthK">
          <div id="monthK" style="height:50vh;"/>
        </van-tab>
        <van-tab title="分钟" name="minuteK">
          <van-row style=" text-align: center; margin-top: 10px; margin-bottom: 10px;">
            <van-tabs v-model="activeMinuteTab">
              <van-tab title="1m" name="m1">
              </van-tab>
              <van-tab title="5m" name="m5">
              </van-tab>
              <van-tab title="15m" name="m15">
              </van-tab>
              <van-tab title="30m" name="m30">
              </van-tab>
              <van-tab title="1小时" name="m60">
              </van-tab>
            </van-tabs>
          </van-row>
          <div id="minuteK" style="height:50vh;"/>
        </van-tab>
      </van-tabs>
    </div>
    <div class="buySellLink" style="background: #ebedf0" v-if="!hideTrading">
      <van-row style="text-align: center; line-height: 20px">
        <van-col
          span="8"
          @click="
            $store.commit('setSearchSecltedShare', selectedShare);
            $router.push({ name: 'Trading', params: { mode: 'buy' } });
          "
        >
          <img
            src="../assets/images/buy@2x.png"
            style="width: 30px; padding-top: 8px"
        /></van-col>
        <van-col
          span="8"
          @click="
            $store.commit('setSearchSecltedShare', selectedShare);
            $router.push({ name: 'Trading', params: { mode: 'sell' } });
          "
          ><img
            src="../assets/images/sell@2x.png"
            style="width: 30px; padding-top: 8px"
        /></van-col>
        <van-col span="8" v-if="isFavourite" @click="addRemoveConcern"
          ><img
            src="../assets/images/like_h@2x.png"
            style="width: 30px; padding-top: 8px"
        /></van-col>
        <van-col span="8" v-if="!isFavourite" @click="addRemoveConcern"
          ><img
            src="../assets/images/like_n@2x.png"
            style="width: 30px; padding-top: 8px"
        /></van-col>
      </van-row>
      <van-row style="text-align: center; line-height: 10px; font-size: 12px">
        <van-col span="8"> <span>买入</span></van-col>
        <van-col span="8"><span>卖出</span></van-col>
        <van-col span="8"><span>自选</span></van-col>
      </van-row>
    </div>
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
// import "./../assets/js/jquery-1.11.0.min.js";
// import "../assets/js/jquery.min.js";
// import "../assets/js/jquery.mousewheel.js";
// import { setMinuteLineChart } from "../assets/js/linechart";
// import { setDayLineChart } from "../assets/js/linechart";
// import { setMinuteChartData } from "../assets/js/candlestick";
// import { setFiveChartData } from "../assets/js/candlestick";
// import { setFifteenChartData } from "../assets/js/candlestick";
// import { setThirtyChartData } from "../assets/js/candlestick";
// import { setHourChartData } from "../assets/js/candlestick";
import * as echarts from "echarts";
import "./../assets/js/jquery-1.11.0.min.js";
import CommonLoading from "./CommonLoading";
import { init } from 'klinecharts';
import { getStyle } from "./../Kline/style.js"
const styles = getStyle()
export default {
  name: "Kline",
  components: {
    CommonLoading,
  },
  data() {
    return {
      activeKlineTab: "timeshare",
      activeMinuteTab: "m1",
      refreshInterval: 2000,
      selectedShare: "sh600010",
      timerRef: null,
      timerRefTop: null,
      topData: {
        name: "--",
      },
      loadingMask: false,
      isFavourite: false,
      hideTrading: false,
      navigateUrl:"",
      daychart: '',
      weekchart: '',
      monthchart: '',
      minutechart: ''
    };
  },
  computed: {},
  methods: {
    /**
     * add or remove fav.
     * check current fav status and call to nozzzle accordingly
     */
    addRemoveConcern() {
      let that = this;
      // that.loadingMask = true;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: that.isFavourite ? "cancel_concern" : "join_concern",
            token: sessionStorage.getItem("token"),
            code: that.selectedShare.substring(2, 8),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.isFavourite = !that.isFavourite;
            // that.loadingMask = false;
            that.$refs.commonLoader.hideCommonLoadigIcon();
          } else if (res.data.code === 0) {
            that.$toast.fail(res.data.msg);
          } else if (res.data.code === -1) {
            that.$logout(res.data.msg);
          }
        })
        .finally(() => {
          // that.loadingMask = false;
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },
    /**
     * check if current stock in fav list
     */
    checkFavourite() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "query_concern",
            token: sessionStorage.getItem("token"),
            code: that.selectedShare.substring(2, 8),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.isFavourite = res.data.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            // that.$toast.fail(res.data.msg);
          }
        });
    },
    //load top data content
    loadTopData() {
      let that = this;
      let url = "https://sqt.gtimg.cn/utf8/q=" + that.selectedShare;
      $.ajax({
        url: url,
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          // var array = [];
          var topDataNw = {};

          elements = eval("v_" + that.selectedShare).split("~");

          topDataNw.name = elements[1]; // 股票名称
          topDataNw.code = elements[2]; // 不带字幕的股票代码，603045
          topDataNw.price = elements[3]; // 当前价格
          topDataNw.yesterdayClosePrice = elements[4]; // 昨收
          topDataNw.todayOpenPrice = elements[5]; // 今开

          topDataNw.buy1Price = elements[9]; // 买1价格
          topDataNw.buy1Num = elements[10]; // 买1数量（手）
          topDataNw.buy2Price = elements[11]; // 买2价格
          topDataNw.buy2Num = elements[12]; // 买2数量（手）
          topDataNw.buy3Price = elements[13]; // 买3价格
          topDataNw.buy3Num = elements[14]; // 买3数量（手）
          topDataNw.buy4Price = elements[15]; // 买4价格
          topDataNw.buy4Num = elements[16]; // 买4数量（手）
          topDataNw.buy5Price = elements[17]; // 买5价格
          topDataNw.buy5Num = elements[18]; // 买5数量（手）

          topDataNw.sell1Price = elements[19]; // 卖1价格
          topDataNw.sell1Num = elements[20]; // 卖1数量（手）
          topDataNw.sell2Price = elements[21]; // 卖2价格
          topDataNw.sell2Num = elements[22]; // 卖2数量（手）
          topDataNw.sell3Price = elements[23]; // 卖3价格
          topDataNw.sell3Num = elements[24]; // 卖3数量（手）
          topDataNw.sell4Price = elements[25]; // 卖4价格
          topDataNw.sell4Num = elements[26]; // 卖4数量（手）
          topDataNw.sell5Price = elements[27]; // 卖5价格
          topDataNw.sell5Num = elements[28]; // 卖5数量（手）

          topDataNw.increase = elements[31]; // 涨、跌额
          topDataNw.increasePercent = elements[32]; // 涨、跌幅
          topDataNw.maxPrice = elements[33]; // 最高价
          topDataNw.minPrice = elements[34]; // 最低价

          topDataNw.num = elements[36]; // 成交量(手)
          topDataNw.totalAccount = elements[37]; // 成交额(万)
          topDataNw.turnoverRate = elements[38]; // 换手率
          topDataNw.priceToEarnings = elements[39]; // 市盈率

          topDataNw.swing = elements[43]; // 振幅
          topDataNw.stockMarketsFell = elements[44]; // 流通市值(亿)
          topDataNw.aggregatealueListedStock = elements[45]; // 总市值(亿)
          topDataNw.price2BookRatio = elements[46]; // 市净率
          topDataNw.hardenPrice = elements[47]; // 涨停价
          topDataNw.dropPrice = elements[48]; // 跌停价
          topDataNw.volumeRatio = elements[49]; // 量比
          topDataNw.appointment = elements[74]; // 尾差
          topDataNw.average = elements[51]; // 均价

          that.$nextTick(() => {
            that.topData = topDataNw;
          });
        },
        complete: function () {
          // that.loadingMask = false;
          that.$refs.commonLoader.hideCommonLoadigIcon();
        },
      });
    },
    /**
     * load data for kline. consider which kline now showing and load
     * data for that kline chart
     */
    loadData() {
      switch (this.activeKlineTab) {
        case "timeshare":
          this.loadTimeShareData(this.selectedShare);
          break;
        case "dayK":
          this.loadklineData(this.selectedShare, "day", "dayK");
          break;
        case "weekK":
          this.loadklineData(this.selectedShare, "week", "weekK");
          break;
        case "monthK":
          this.loadklineData(this.selectedShare, "month", "monthK");
          break;
        case "minuteK":
          if(this.activeMinuteTab == 'm1'){
           this.loadklineData(this.selectedShare, "m1", "minuteK");
          }else if(this.activeMinuteTab == 'm5'){
            this.loadklineData(this.selectedShare, "m5", "minuteK");
          }else if(this.activeMinuteTab == 'm15'){
            this.loadklineData(this.selectedShare, "m15", "minuteK");
          }else if(this.activeMinuteTab == 'm30'){
            this.loadklineData(this.selectedShare, "m30", "minuteK");
          }else {
            this.loadklineData(this.selectedShare, "m60", "minuteK");
          }
          break;
        default:
          // console.log("default");
          break;
      }
    },
    /**
     * fire when chart tab change
     * 1.clear background data loading
     * 2.get data for current kline
     * 3.start background data loading
     */
    chartChange() {
      clearInterval(this.timerRef);
      this.loadData();
      this.timerRef = setInterval(() => {
        this.loadData();
      }, this.refreshInterval);
    },
    /**
     * init and refresh timeshare chart
     */
    loadTimeShare(xData, yData) {
      var myChart = echarts.init(document.getElementById("timeshare"));

      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "15%",
        },
        xAxis: {
          type: "category",
          data: xData,
          scale: true,
          boundaryGap: true,
          axisLine: { onZero: false },
          splitLine: { show: true },
          splitNumber: 20,
          min: "dataMin",
          max: "dataMax",
        },
        yAxis: {
          scale: true,
          splitArea: {
            show: true,
          },
        },
        dataZoom: [
          // {
          //   type: "inside",
          //   start: 90,
          //   end: 100,
          // },
          { type: "inside", show: true, realtime: true },
          {
            show: true,
            type: "slider",
            top: "90%",
            realtime: true,
          },
        ],
        series: [
          {
            type: "line",
            data: yData,
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    /**
     * get data for timeshare chart
     */
    loadTimeShareData(code) {
      let that = this;
      $.get(
        "https://ifzq.gtimg.cn/appstock/app/minute/query?code=" +
          code +
          "&r=" +
          new Date().getTime(),
        function (res) {
          res = JSON.parse(res);
          let data = res.data[code].data.data;
          let priceArray = [],
            timeArray = [];
          data.forEach((element) => {
            element = element.split(" ");
            priceArray.push(element[1]);
            timeArray.push(element[0]);
          });

          that.loadTimeShare(timeArray, priceArray);
        }
      );
    },
    loadNewKline(data, chartId){
      if((this.daychart == '' || this.daychart == null) && chartId == 'dayK'){
        this.daychart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.daychart.createIndicator('VOL')
      }

      if((this.weekchart == '' || this.weekchart == null) && chartId == 'weekK'){
        this.weekchart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.weekchart.createIndicator('VOL');
      }

      if((this.monthchart == '' || this.monthchart == null) && chartId == 'monthK'){
        this.monthchart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.monthchart.createIndicator('VOL');
      }

      if((this.minutechart == '' || this.minutechart == null) && chartId == 'minuteK'){
        this.minutechart = init(document.getElementById(chartId),{ locale: 'en-US' });
        this.minutechart.createIndicator('VOL');
      }

      data = splitData(data);
      if(chartId == 'dayK'){
        this.daychart.applyNewData(data.categoryData)
        this.daychart.setStyles(styles)
      }else if(chartId == 'weekK'){
        this.weekchart.applyNewData(data.categoryData)
        this.weekchart.setStyles(styles)
      }else if(chartId == 'monthK'){
        this.monthchart.applyNewData(data.categoryData)
        this.monthchart.setStyles(styles)
      }else if(chartId == 'minuteK'){
        this.minutechart.applyNewData(data.categoryData)
        this.minutechart.setStyles(styles)
      }

      function splitData(rawData) {
        var categoryData = [];
        for (var i = 0; i < rawData.length; i++) {
          var newTimeStamp = '';
          if(chartId == 'minuteK'){
            // Handle full timestamp in "YYYYMMDDHHMM" format
            var mtimestamp = rawData[i].splice(0, 1)[0];
            const year = mtimestamp.slice(0, 4);
            const month = mtimestamp.slice(4, 6);
            const day = mtimestamp.slice(6, 8);
            const hour = mtimestamp.slice(8, 10);
            const minute = mtimestamp.slice(10, 12);

            newTimeStamp = new Date(`${year}-${month}-${day}T${hour}:${minute}:00`).getTime();
          }else{
            newTimeStamp = new Date(rawData[i].splice(0, 1)[0]).getTime();
          }
          categoryData.push({
            timestamp: newTimeStamp,
            open: Number(rawData[i].splice(0, 1)[0]),
            close: Number(rawData[i].splice(0, 1)[0]),
            high: Number(rawData[i].splice(0, 1)[0]),
            low: Number(rawData[i].splice(0, 1)[0]),
            volume: Number(rawData[i].splice(0, 1)[0])
          });
        }
        return {
          categoryData: categoryData,
        };
      }
      
    },
    /**
     * init and refresh candlestick charts
     */
    loadKline(data, chartId) {
      var myChart = echarts.init(document.getElementById(chartId));
      var option;

      var upColor = "#ec0000";
      var upBorderColor = "#8A0000";
      var downColor = "#00da3c";
      var downBorderColor = "#008F28";

      data = splitData(data);

      function splitData(rawData) {
        var categoryData = [];
        var values = [];
        for (var i = 0; i < rawData.length; i++) {
          categoryData.push(rawData[i].splice(0, 1)[0]);
          values.push(rawData[i]);
        }
        return {
          categoryData: categoryData,
          values: values,
        };
      }

      function calculateMA(dayCount) {
        var result = [];
        for (var i = 0, len = data.values.length; i < len; i++) {
          if (i < dayCount) {
            result.push("-");
            continue;
          }
          var sum = 0;
          for (var j = 0; j < dayCount; j++) {
            sum += parseFloat(data.values[i - j][1]);
          }
          result.push(sum / dayCount);
        }
        return result;
      }

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "15%",
        },
        xAxis: {
          type: "category",
          data: data.categoryData,
          scale: true,
          boundaryGap: false,
          axisLine: { onZero: false },
          splitLine: { show: false },
          splitNumber: 20,
          min: "dataMin",
          max: "dataMax",
        },
        yAxis: {
          scale: true,
          splitArea: {
            show: true,
          },
        },
        dataZoom: [
          {
            type: "inside",
            // dataZoomIndex:"50",
            realtime: true,
            // start: 80,
            // end: 100,
          },
          {
            show: true,
            type: "slider",
            top: "90%",
            realtime: true,
          },
        ],
        series: [
          {
            name: "日K",
            type: "candlestick",
            data: data.values,
            itemStyle: {
              color: upColor,
              color0: downColor,
              borderColor: upBorderColor,
              borderColor0: downBorderColor,
            },
            markPoint: {
              label: {
                normal: {
                  formatter: function (param) {
                    return param != null ? Math.round(param.value) : "";
                  },
                },
              },
              data: [
                {
                  name: "XX标点",
                  coord: ["2013/5/31", 2300],
                  value: 2300,
                  itemStyle: {
                    color: "rgb(41,60,85)",
                  },
                },
                {
                  name: "highest value",
                  type: "max",
                  valueDim: "highest",
                },
                {
                  name: "lowest value",
                  type: "min",
                  valueDim: "lowest",
                },
                {
                  name: "average value on close",
                  type: "average",
                  valueDim: "close",
                },
              ],
              tooltip: {
                formatter: function (param) {
                  return param.name + "<br>" + (param.data.coord || "");
                },
              },
            },
            markLine: {
              symbol: ["none", "none"],
              data: [
                [
                  {
                    name: "from lowest to highest",
                    type: "min",
                    valueDim: "lowest",
                    symbol: "circle",
                    symbolSize: 10,
                    label: {
                      show: false,
                    },
                    emphasis: {
                      label: {
                        show: false,
                      },
                    },
                  },
                  {
                    type: "max",
                    valueDim: "highest",
                    symbol: "circle",
                    symbolSize: 10,
                    label: {
                      show: false,
                    },
                    emphasis: {
                      label: {
                        show: false,
                      },
                    },
                  },
                ],
                {
                  name: "min line on close",
                  type: "min",
                  valueDim: "close",
                },
                {
                  name: "max line on close",
                  type: "max",
                  valueDim: "close",
                },
              ],
            },
          },
          {
            name: "MA5",
            type: "line",
            data: calculateMA(5),
            smooth: true,
            lineStyle: {
              opacity: 0.5,
            },
          },
          {
            name: "MA10",
            type: "line",
            data: calculateMA(10),
            smooth: true,
            lineStyle: {
              opacity: 0.5,
            },
          },
          {
            name: "MA20",
            type: "line",
            data: calculateMA(20),
            smooth: true,
            lineStyle: {
              opacity: 0.5,
            },
          },
          {
            name: "MA30",
            type: "line",
            data: calculateMA(30),
            smooth: true,
            lineStyle: {
              opacity: 0.5,
            },
          },
        ],
      };

      myChart.setOption(option);
    },
    /**
     * get data for candlestick charts
     */
    loadklineData(code, type, chartId) {
      let limit = 400, url,
        that = this;
      if (type === "m1" || type === "m5" || type === "m15" || type === "m30" | type === "m60") {
        url = "https://ifzq.gtimg.cn/appstock/app/kline/mkline?param=";
      } else {
        url = "https://ifzq.gtimg.cn/appstock/app/kline/kline?param=";
      }
      $.get(
        url + code + "," + type + ",,,"+limit+"," + "&r=" + new Date().getTime(),
        function (res) {
          res = JSON.parse(res);
          let data = res.data[code][type];
          that.loadNewKline(data, chartId);
        }
      );
    },
  },
  mounted: function () {
    // let that = this;
    this.selectedShare = this.$route.params.code;
    if (
      this.selectedShare === "sh000001" ||
      this.selectedShare === "sz399001" ||
      this.selectedShare === "sz399006"
    )
      this.hideTrading = true;
    // this.loadingMask = true;
    this.$refs.commonLoader.showCommonLoadigIcon();
    this.loadTopData();
    this.chartChange();
    this.checkFavourite();
    // this.loadData();
    this.timerRefTop = setInterval(() => {
      this.loadTopData();
    }, this.refreshInterval);
  },
  created: function () {},
  /**
   * when page moves to another page, clear background data getters
   */
  destroyed: function () {
    clearInterval(this.timerRef);
    clearInterval(this.timerRefTop);
  },
};
</script>

<style scoped>
.buySellLink {
  text-align: center;
  /* position: fixed; */
  bottom: 50px;
  width: 100%;
  height: 60px;
  line-height: 40px;
}
.redText {
  color: #F92855;
}
.greenText {
  color: #2DC08E;
}
</style>



// WEBPACK FOOTER //
// src/components/Kline.vue